module.exports = __webpack_public_path__ + "img/engine_compartment.de49d01c.jpg";